export default __webpack_public_path__ + "static/media/Nainital04.40f60d17.jpg";